import React from "react"
import { InternalTitleBlockWrapper, TagsList, NewsInfo } from "./style"

const InternalTitleBlock = ({ tags, author, date, news, text }) => {
  return (
    <InternalTitleBlockWrapper>
      {text && (
        <h2
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      )}
      {!news && tags && (
        <TagsList>
          {tags.map((tag, index) => {
            return <li key={`tag${index}`}>{tag}</li>
          })}
        </TagsList>
      )}

      {news && author && date && (
        <NewsInfo>
          <li>{author}</li>
          <span>{date}</span>
        </NewsInfo>
      )}
    </InternalTitleBlockWrapper>
  )
}

export default InternalTitleBlock
